<template>
  <div class="position-relative">
    <PopoverMenu
      slot="popover"
      class="font-size-xs"
      :position="position"
      :items="items"
      target-selector="svg"
      :closest="$el"
      auto-close
      @toggle="toggle"
    >
      <template slot-scope="{ item }">
        <span @click.stop="item.action">{{ item.label }}</span>
      </template>
    </PopoverMenu>
  </div>
</template>

<script>
import PopoverMenu from '@/components/popover/Menu';
export default {
  name: 'PopoverActions',
  components: { PopoverMenu },
  model: {
    prop: 'position',
    event: 'toggle',
  },
  props: {
    position: {
      type: [Object, Node],
      default: null,
    },
    items: {
      type: [Object, Array],
      default: () => [],
    },
  },
  methods: {
    toggle(isVisible) {
      if (!isVisible) {
        this.$emit('toggle', null);
      }
    },
  },
};
</script>
